import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _spacing, _desktop, _typography;
import { BREAKPOINTS } from './breakpoints';
var SPACING_BASE = '--g-spacing-base';
var SC_SPACING_BASE = '--sc-spacing-base';
var FONT_SIZE_100 = '--g-font-size-100';
var FONT_SIZE_200 = '--g-font-size-200';
var FONT_SIZE_300 = '--g-font-size-300';
var FONT_SIZE_400 = '--g-font-size-400';
var FONT_SIZE_500 = '--g-font-size-500';
var FONT_SIZE_600 = '--g-font-size-600';
var FONT_SIZE_700 = '--g-font-size-700';
var FONT_SIZE_800 = '--g-font-size-800';
var FONT_SIZE_900 = '--g-font-size-900';
var FONT_SIZE_1000 = '--g-font-size-1000';
var LINE_HEIGHT_100 = '--g-line-height-100';
var LINE_HEIGHT_200 = '--g-line-height-200';
var LINE_HEIGHT_300 = '--g-line-height-300';
var LINE_HEIGHT_400 = '--g-line-height-400';
var LINE_HEIGHT_500 = '--g-line-height-500';
var LINE_HEIGHT_600 = '--g-line-height-600';
var LINE_HEIGHT_700 = '--g-line-height-700';
var LINE_HEIGHT_800 = '--g-line-height-800';
var LINE_HEIGHT_900 = '--g-line-height-900';
var LINE_HEIGHT_1000 = '--g-line-height-1000';
var FONT_FAMILY_DEFAULT = '--g-font-family-default';
var FONT_FAMILY_HEADING = '--g-font-family-heading';
var FONT_WEIGHT_LIGHT = '--g-font-weight-light';
var FONT_WEIGHT_SEMILIGHT = '--g-font-weight-semilight';
var FONT_WEIGHT_REGULAR = '--g-font-weight-regular';
var FONT_WEIGHT_MEDIUM = '--g-font-weight-medium';
var FONT_WEIGHT_SEMIBOLD = '--g-font-weight-semibold';
var FONT_WEIGHT_BOLD = '--g-font-weight-bold';
var FONT_WEIGHT_HEADING = '--g-font-weight-headings';
var FONT_WEIGHT_DEFAULT = '--g-font-weight-default';
var themeVariables = {
  spacing: (_spacing = {}, _defineProperty(_spacing, SPACING_BASE, '8px'), _defineProperty(_spacing, '--g-spacing-0', "0"), _defineProperty(_spacing, '--g-spacing-1', "calc(var(".concat(SPACING_BASE, ") / 4)")), _defineProperty(_spacing, '--g-spacing-2', "calc(var(".concat(SPACING_BASE, ") / 2)")), _defineProperty(_spacing, '--g-spacing-3', "var(".concat(SPACING_BASE, ")")), _defineProperty(_spacing, '--g-spacing-4', "calc(var(".concat(SPACING_BASE, ") * 2)")), _defineProperty(_spacing, '--g-spacing-5', "calc(var(".concat(SPACING_BASE, ") * 3)")), _defineProperty(_spacing, '--g-spacing-6', "calc(var(".concat(SPACING_BASE, ") * 4)")), _defineProperty(_spacing, '--g-spacing-7', "calc(var(".concat(SPACING_BASE, ") * 5)")), _defineProperty(_spacing, '--g-spacing-8', "calc(var(".concat(SPACING_BASE, ") * 6)")), _defineProperty(_spacing, '--g-spacing-9', "calc(var(".concat(SPACING_BASE, ") * 7)")), _defineProperty(_spacing, '--g-spacing-10', "calc(var(".concat(SPACING_BASE, ") * 8)")), _defineProperty(_spacing, '--g-spacing-11', "calc(var(".concat(SPACING_BASE, ") * 9)")), _defineProperty(_spacing, '--g-spacing-12', "calc(var(".concat(SPACING_BASE, ") * 10)")), _defineProperty(_spacing, '--g-spacing-13', "calc(var(".concat(SPACING_BASE, ") * 11)")), _defineProperty(_spacing, '--g-spacing-14', "calc(var(".concat(SPACING_BASE, ") * 12)")), _defineProperty(_spacing, '--g-spacing-15', "calc(var(".concat(SPACING_BASE, ") * 13)")), _defineProperty(_spacing, '--g-spacing-16', "calc(var(".concat(SPACING_BASE, ") * 14)")), _defineProperty(_spacing, '--g-spacing-17', "calc(var(".concat(SPACING_BASE, ") * 15)")), _defineProperty(_spacing, '--g-spacing-18', "calc(var(".concat(SPACING_BASE, ") * 16)")), _defineProperty(_spacing, '--g-spacing-19', "calc(var(".concat(SPACING_BASE, ") * 17)")), _defineProperty(_spacing, '--g-spacing-20', "calc(var(".concat(SPACING_BASE, ") * 18)")), _defineProperty(_spacing, '--g-spacing-21', "calc(var(".concat(SPACING_BASE, ") * 19)")), _defineProperty(_spacing, '--g-spacing-22', "calc(var(".concat(SPACING_BASE, ") * 20)")), _defineProperty(_spacing, '--g-spacing-23', "calc(var(".concat(SPACING_BASE, ") * 21)")), _defineProperty(_spacing, '--g-spacing-24', "calc(var(".concat(SPACING_BASE, ") * 22)")), _defineProperty(_spacing, '--sc-spacing-1', "calc(var(".concat(SC_SPACING_BASE, ") / 4)")), _defineProperty(_spacing, '--sc-spacing-2', "calc(var(".concat(SC_SPACING_BASE, ") / 2)")), _defineProperty(_spacing, '--sc-spacing-3', "var(".concat(SC_SPACING_BASE, ")")), _defineProperty(_spacing, '--sc-spacing-4', "calc(var(".concat(SC_SPACING_BASE, ") * 2)")), _defineProperty(_spacing, '--sc-spacing-5', "calc(var(".concat(SC_SPACING_BASE, ") * 3)")), _defineProperty(_spacing, '--sc-spacing-6', "calc(var(".concat(SC_SPACING_BASE, ") * 4)")), _defineProperty(_spacing, '--sc-spacing-7', "calc(var(".concat(SC_SPACING_BASE, ") * 5)")), _defineProperty(_spacing, '--sc-spacing-8', "calc(var(".concat(SC_SPACING_BASE, ") * 6)")), _defineProperty(_spacing, '--sc-spacing-9', "calc(var(".concat(SC_SPACING_BASE, ") * 7)")), _defineProperty(_spacing, '--sc-spacing-10', "calc(var(".concat(SC_SPACING_BASE, ") * 8)")), _defineProperty(_spacing, '--sc-spacing-11', "calc(var(".concat(SC_SPACING_BASE, ") * 9)")), _defineProperty(_spacing, '--sc-spacing-12', "calc(var(".concat(SC_SPACING_BASE, ") * 10)")), _defineProperty(_spacing, '--sc-spacing-13', "calc(var(".concat(SC_SPACING_BASE, ") * 11)")), _defineProperty(_spacing, '--sc-spacing-14', "calc(var(".concat(SC_SPACING_BASE, ") * 12)")), _defineProperty(_spacing, '--sc-spacing-15', "calc(var(".concat(SC_SPACING_BASE, ") * 13)")), _defineProperty(_spacing, '--sc-spacing-16', "calc(var(".concat(SC_SPACING_BASE, ") * 14)")), _defineProperty(_spacing, '--sc-spacing-17', "calc(var(".concat(SC_SPACING_BASE, ") * 15)")), _defineProperty(_spacing, '--sc-spacing-18', "calc(var(".concat(SC_SPACING_BASE, ") * 16)")), _defineProperty(_spacing, '--g-spacing-block-section', 'var(--g-spacing-6)'), _defineProperty(_spacing, "desktop", {
    '--g-spacing-block-section': 'var(--g-spacing-12)'
  }), _spacing),
  borderRadius: {
    '--g-border-radius': '',
    '--g-border-radius-1': '2px',
    '--g-border-radius-2': '4px',
    '--g-border-radius-3': '6px',
    '--g-border-radius-4': '8px',
    '--g-border-radius-5': '12px',
    '--g-border-radius-6': '16px',
    '--g-border-radius-7': '22px',
    '--g-border-radius-full': '9999px'
  },
  stroke: {
    '--g-stroke-width': '',
    '--g-stroke-width-thin': '1px',
    '--g-stroke-width-thick': '2px',
    '--g-stroke-width-thicker': '3px',
    '--g-stroke-width-thickest': '4px'
  },
  motion: {
    '--g-transition-duration-short-1': '50ms',
    '--g-transition-duration-short-2': '100ms',
    '--g-transition-duration-short-3': '150ms',
    '--g-transition-duration-medium-1': '200ms',
    '--g-transition-duration-medium-2': '250ms',
    '--g-transition-duration-medium-3': '300ms',
    '--g-transition-duration-long-1': '400ms',
    '--g-transition-duration-long-2': '500ms',
    '--g-transition-easing-linear': 'cubic-bezier(0, 0, 1, 1)',
    '--g-transition-easing-ease-1': 'cubic-bezier(0.33, 0, 0.67, 1)',
    '--g-transition-easing-ease-2': 'cubic-bezier(0.80, 0, 0.2, 1)',
    '--g-transition-easing-decelerate-1': 'cubic-bezier(0.33, 0, 0.1, 1)',
    '--g-transition-easing-decelerate-2': 'cubic-bezier(0, 0, 0, 1)',
    '--g-transition-easing-decelerate-3': 'cubic-bezier(0.1, 0.9, 0.2, 1)',
    '--g-transition-easing-accelerate-1': 'cubic-bezier(0.8, 0, 0.78, 1)',
    '--g-transition-easing-accelerate-2': 'cubic-bezier(1, 0, 1, 1)',
    '--g-transition-easing-accelerate-3': 'cubic-bezier(0.9, 0.1, 1, 0.2)'
  }
};
export var skinVariables = {
  typography: (_typography = {}, _defineProperty(_typography, FONT_SIZE_100, '0.75rem'), _defineProperty(_typography, FONT_SIZE_200, '0.8125rem'), _defineProperty(_typography, FONT_SIZE_300, '0.875rem'), _defineProperty(_typography, FONT_SIZE_400, '1rem;'), _defineProperty(_typography, FONT_SIZE_500, '1.125rem'), _defineProperty(_typography, FONT_SIZE_600, '1.25rem'), _defineProperty(_typography, FONT_SIZE_700, '1.375rem'), _defineProperty(_typography, FONT_SIZE_800, '1.5rem'), _defineProperty(_typography, FONT_SIZE_900, '1.875rem'), _defineProperty(_typography, FONT_SIZE_1000, '2.25rem'), _defineProperty(_typography, LINE_HEIGHT_100, '1.16667'), _defineProperty(_typography, LINE_HEIGHT_200, '1.23077'), _defineProperty(_typography, LINE_HEIGHT_300, '1.42857'), _defineProperty(_typography, LINE_HEIGHT_400, '1.375'), _defineProperty(_typography, LINE_HEIGHT_500, '1.33333'), _defineProperty(_typography, LINE_HEIGHT_600, '1.4'), _defineProperty(_typography, LINE_HEIGHT_700, '1.54545'), _defineProperty(_typography, LINE_HEIGHT_800, '1.58333'), _defineProperty(_typography, LINE_HEIGHT_900, '1.33333'), _defineProperty(_typography, LINE_HEIGHT_1000, '1.22222'), _defineProperty(_typography, "desktop", (_desktop = {}, _defineProperty(_desktop, FONT_SIZE_100, '0.625rem'), _defineProperty(_desktop, FONT_SIZE_200, '0.8125rem'), _defineProperty(_desktop, FONT_SIZE_300, '1rem'), _defineProperty(_desktop, FONT_SIZE_400, '1.125rem'), _defineProperty(_desktop, FONT_SIZE_500, '1.25rem'), _defineProperty(_desktop, FONT_SIZE_600, '1.375rem'), _defineProperty(_desktop, FONT_SIZE_700, '1.5rem'), _defineProperty(_desktop, FONT_SIZE_800, '1.75rem'), _defineProperty(_desktop, FONT_SIZE_900, '2.25rem'), _defineProperty(_desktop, FONT_SIZE_1000, '3.375rem'), _defineProperty(_desktop, LINE_HEIGHT_100, '1.2'), _defineProperty(_desktop, LINE_HEIGHT_200, '1.23077'), _defineProperty(_desktop, LINE_HEIGHT_300, '1.25'), _defineProperty(_desktop, LINE_HEIGHT_400, '1.33333'), _defineProperty(_desktop, LINE_HEIGHT_500, '1.4'), _defineProperty(_desktop, LINE_HEIGHT_600, '1.45454'), _defineProperty(_desktop, LINE_HEIGHT_700, '1.5'), _defineProperty(_desktop, LINE_HEIGHT_800, '1.42857'), _defineProperty(_desktop, LINE_HEIGHT_900, '1.33333'), _defineProperty(_desktop, LINE_HEIGHT_1000, '1.18519'), _desktop)), _defineProperty(_typography, FONT_FAMILY_DEFAULT, ''), _defineProperty(_typography, FONT_FAMILY_HEADING, ''), _defineProperty(_typography, '--g-font-family-h1', "var(".concat(FONT_FAMILY_HEADING, ")")), _defineProperty(_typography, '--g-font-family-h2', "var(".concat(FONT_FAMILY_HEADING, ")")), _defineProperty(_typography, '--g-font-family-h3', "var(".concat(FONT_FAMILY_HEADING, ")")), _defineProperty(_typography, '--g-font-family-h4', "var(".concat(FONT_FAMILY_HEADING, ")")), _defineProperty(_typography, '--g-font-family-h5', "var(".concat(FONT_FAMILY_HEADING, ")")), _defineProperty(_typography, '--g-font-family-h6', "var(".concat(FONT_FAMILY_HEADING, ")")), _defineProperty(_typography, '--g-font-family-subtitle1', "var(".concat(FONT_FAMILY_DEFAULT, ")")), _defineProperty(_typography, '--g-font-family-subtitle2', "var(".concat(FONT_FAMILY_DEFAULT, ")")), _defineProperty(_typography, '--g-font-family-body1', "var(".concat(FONT_FAMILY_DEFAULT, ")")), _defineProperty(_typography, '--g-font-family-body2', "var(".concat(FONT_FAMILY_DEFAULT, ")")), _defineProperty(_typography, '--g-font-family-button', "var(".concat(FONT_FAMILY_DEFAULT, ")")), _defineProperty(_typography, '--g-font-family-caption', "var(".concat(FONT_FAMILY_DEFAULT, ")")), _defineProperty(_typography, '--g-font-family-overline', "var(".concat(FONT_FAMILY_DEFAULT, ")")), _defineProperty(_typography, '--g-font-size-h1', "var(".concat(FONT_SIZE_1000, ")")), _defineProperty(_typography, '--g-font-size-h2', "var(".concat(FONT_SIZE_900, ")")), _defineProperty(_typography, '--g-font-size-h3', "var(".concat(FONT_SIZE_800, ")")), _defineProperty(_typography, '--g-font-size-h4', "var(".concat(FONT_SIZE_700, ")")), _defineProperty(_typography, '--g-font-size-h5', "var(".concat(FONT_SIZE_600, ")")), _defineProperty(_typography, '--g-font-size-h6', "var(".concat(FONT_SIZE_500, ")")), _defineProperty(_typography, '--g-font-size-subtitle1', "var(".concat(FONT_SIZE_400, ")")), _defineProperty(_typography, '--g-font-size-subtitle2', "var(".concat(FONT_SIZE_300, ")")), _defineProperty(_typography, '--g-font-size-body1', "var(".concat(FONT_SIZE_500, ")")), _defineProperty(_typography, '--g-font-size-body2', "var(".concat(FONT_SIZE_400, ")")), _defineProperty(_typography, '--g-font-size-button', "var(".concat(FONT_SIZE_300, ")")), _defineProperty(_typography, '--g-font-size-caption', "var(".concat(FONT_SIZE_200, ")")), _defineProperty(_typography, '--g-font-size-overline', "var(".concat(FONT_SIZE_100, ")")), _defineProperty(_typography, '--g-line-height-h1', "var(".concat(LINE_HEIGHT_1000, ")")), _defineProperty(_typography, '--g-line-height-h2', "var(".concat(LINE_HEIGHT_900, ")")), _defineProperty(_typography, '--g-line-height-h3', "var(".concat(LINE_HEIGHT_800, ")")), _defineProperty(_typography, '--g-line-height-h4', "var(".concat(LINE_HEIGHT_700, ")")), _defineProperty(_typography, '--g-line-height-h5', "var(".concat(LINE_HEIGHT_600, ")")), _defineProperty(_typography, '--g-line-height-h6', "var(".concat(LINE_HEIGHT_500, ")")), _defineProperty(_typography, '--g-line-height-subtitle1', "var(".concat(LINE_HEIGHT_400, ")")), _defineProperty(_typography, '--g-line-height-subtitle2', "var(".concat(LINE_HEIGHT_300, ")")), _defineProperty(_typography, '--g-line-height-body1', "var(".concat(LINE_HEIGHT_500, ")")), _defineProperty(_typography, '--g-line-height-body2', "var(".concat(LINE_HEIGHT_400, ")")), _defineProperty(_typography, '--g-line-height-button', "var(".concat(LINE_HEIGHT_300, ")")), _defineProperty(_typography, '--g-line-height-caption', "var(".concat(LINE_HEIGHT_200, ")")), _defineProperty(_typography, '--g-line-height-overline', "var(".concat(LINE_HEIGHT_100, ")")), _defineProperty(_typography, FONT_WEIGHT_LIGHT, '200'), _defineProperty(_typography, FONT_WEIGHT_SEMILIGHT, '300'), _defineProperty(_typography, FONT_WEIGHT_REGULAR, '400'), _defineProperty(_typography, FONT_WEIGHT_MEDIUM, '500'), _defineProperty(_typography, FONT_WEIGHT_SEMIBOLD, '600'), _defineProperty(_typography, FONT_WEIGHT_BOLD, '700'), _defineProperty(_typography, FONT_WEIGHT_HEADING, "var(".concat(FONT_WEIGHT_SEMIBOLD, ")")), _defineProperty(_typography, FONT_WEIGHT_DEFAULT, "var(".concat(FONT_WEIGHT_REGULAR, ")")), _defineProperty(_typography, '--g-font-weight-h1', "var(".concat(FONT_WEIGHT_HEADING, ")")), _defineProperty(_typography, '--g-font-weight-h2', "var(".concat(FONT_WEIGHT_HEADING, ")")), _defineProperty(_typography, '--g-font-weight-h3', "var(".concat(FONT_WEIGHT_HEADING, ")")), _defineProperty(_typography, '--g-font-weight-h4', "var(".concat(FONT_WEIGHT_HEADING, ")")), _defineProperty(_typography, '--g-font-weight-h5', "var(".concat(FONT_WEIGHT_HEADING, ")")), _defineProperty(_typography, '--g-font-weight-h6', "var(".concat(FONT_WEIGHT_HEADING, ")")), _defineProperty(_typography, '--g-font-weight-subtitle1', "var(".concat(FONT_WEIGHT_DEFAULT, ")")), _defineProperty(_typography, '--g-font-weight-subtitle2', "var(".concat(FONT_WEIGHT_DEFAULT, ")")), _defineProperty(_typography, '--g-font-weight-body1', "var(".concat(FONT_WEIGHT_DEFAULT, ")")), _defineProperty(_typography, '--g-font-weight-body2', "var(".concat(FONT_WEIGHT_DEFAULT, ")")), _defineProperty(_typography, '--g-font-weight-button', "var(".concat(FONT_WEIGHT_DEFAULT, ")")), _defineProperty(_typography, '--g-font-weight-caption', "var(".concat(FONT_WEIGHT_DEFAULT, ")")), _defineProperty(_typography, '--g-font-weight-overline', "var(".concat(FONT_WEIGHT_DEFAULT, ")")), _defineProperty(_typography, '--g-letter-spacing-h1', 'normal'), _defineProperty(_typography, '--g-letter-spacing-h2', 'normal'), _defineProperty(_typography, '--g-letter-spacing-h3', 'normal'), _defineProperty(_typography, '--g-letter-spacing-h4', 'normal'), _defineProperty(_typography, '--g-letter-spacing-h5', 'normal'), _defineProperty(_typography, '--g-letter-spacing-h6', 'normal'), _defineProperty(_typography, '--g-letter-spacing-subtitle1', 'normal'), _defineProperty(_typography, '--g-letter-spacing-subtitle2', 'normal'), _defineProperty(_typography, '--g-letter-spacing-body1', 'normal'), _defineProperty(_typography, '--g-letter-spacing-body2', 'normal'), _defineProperty(_typography, '--g-letter-spacing-button', 'normal'), _defineProperty(_typography, '--g-letter-spacing-caption', 'normal'), _defineProperty(_typography, '--g-letter-spacing-overline', 'normal'), _typography),
  color: {
    // To emphasize or de-emphasize foreground elements
    '--g-color-primary': '',
    '--g-color-primary-contrast': '',
    '--g-color-primary-opacity': '1',
    '--g-color-secondary': '',
    '--g-color-secondary-contrast': '',
    '--g-color-secondary-opacity': '1',
    '--g-color-tertiary': '',
    '--g-color-tertiary-contrast': '',
    '--g-color-tertiary-opacity': '1',
    '--g-color-white': '0 0% 100%',
    // #ffffff
    '--g-color-black': '0 0% 0%',
    // #000000
    '--g-color-light': '0 0% 100%',
    // #ffffff
    '--g-color-dark': '187 100% 7%',
    // #002024

    // Use as a fill color
    '--g-color-primary-container': '',
    '--g-color-primary-container-contrast': '',
    '--g-color-secondary-container': '',
    '--g-color-secondary-container-contrast': '',
    '--g-color-tertiary-container': '',
    '--g-color-tertiary-container-contrast': '',
    // Used for backgrounds and large, low-emphasis areas of the screen
    '--g-color-surface': '26 100% 99%',
    '--g-color-surface-dim': '25 38% 94%',
    '--g-color-surface-bright': '0 0% 100%',
    '--g-color-surface-container': '0 0% 100%',
    '--g-color-surface-container-variant': '25 38% 94%',
    '--g-color-surface-contrast': '0 0% 0%',
    '--g-color-surface-variant-contrast': '0 0% 11%',
    '--g-color-inverse-surface': '30 6% 19%',
    '--g-color-inverse-surface-contrast': '0 0% 100%',
    '--g-color-inverse-primary': '',
    // for actionable elements, like text buttons
    '--g-color-outline': '27 4% 46%',
    '--g-color-outline-variant': '22 10% 78%',
    '--g-color-neutral': '264 5% 58%',
    // #938f99
    '--g-color-neutral-0': '0 0% 100%',
    // #ffffff
    '--g-color-neutral-50': '315 100% 99%',
    // #fffbfe
    '--g-color-neutral-100': '275 55% 96%',
    // #f5eefa
    '--g-color-neutral-200': '275 24% 90%',
    // #e7e0ec
    '--g-color-neutral-300': '270 11% 79%',
    // #cac4d0
    '--g-color-neutral-400': '267 7% 68%',
    // #aea9b4
    '--g-color-neutral-500': '264 5% 58%',
    // #938f99
    '--g-color-neutral-600': '270 4% 47%',
    // #79747
    '--g-color-neutral-700': '260 5% 38%',
    // #605d66
    '--g-color-neutral-800': '264 7% 29%',
    // #49454f
    '--g-color-neutral-900': '263 8% 20%',
    // #322f37
    '--g-color-neutral-950': '263 13% 12%',
    // #1d1a22
    '--g-color-neutral-1000': '0 0% 0%',
    // #000000
    '--g-color-neutral-opacity': '1',
    '--g-color-neutral-contrast': '0 0% 0%',
    // #000000

    '--g-color-error': '3 71% 64%',
    // #e46962
    '--g-color-error-50': '20 100% 99%',
    // #fffbf9
    '--g-color-error-100': '0 70% 96%',
    // #fceeee
    '--g-color-error-200': '4 71% 92%',
    // #f9dedc
    '--g-color-error-300': '3 70% 83%',
    // #f2b8b5
    '--g-color-error-400': '3 71% 74%',
    // #ec928e
    '--g-color-error-500': '3 71% 64%',
    // #e46962
    '--g-color-error-600': '3 71% 52%',
    // #dc362e
    '--g-color-error-700': '3 71% 41%',
    // #b3261e
    '--g-color-error-800': '359 73% 32%',
    // #8c1618
    '--g-color-error-900': '3 71% 22%',
    // #601410
    '--g-color-error-950': '3 71% 15%',
    // #410e0b
    '--g-color-error-opacity': '1',
    '--g-color-error-contrast': '0 0% 0%',
    // #000000

    '--g-color-success': '146 79% 44%',
    // #17c964
    '--g-color-success-50': '147 64% 95%',
    // #e8faf0
    '--g-color-success-100': '146 61% 89%',
    // #d1f4e0
    '--g-color-success-200': '146 62% 77%',
    // #a2e9c1
    '--g-color-success-300': '146 63% 66%',
    // #74dfa2
    '--g-color-success-400': '146 62% 55%',
    // #45d483
    '--g-color-success-500': '146 79% 44%',
    // #17c964
    '--g-color-success-600': '146 80% 35%',
    // #12a150
    '--g-color-success-700': '146 79% 26%',
    // #0e793c
    '--g-color-success-800': '146 75% 20%',
    // #0d5a2f
    '--g-color-success-900': '147 79% 13%',
    // #073d1f
    '--g-color-success-950': '146 81% 8%',
    // #042613
    '--g-color-success-opacity': '1',
    '--g-color-success-contrast': '0 0% 0%',
    // #000000

    '--g-color-warning': '37 91% 55%',
    // #f5a524
    '--g-color-warning-50': '55 92% 95%',
    // #fefce8
    '--g-color-warning-100': '37 91% 91%',
    // #fdedd3
    '--g-color-warning-200': '37 91% 82%',
    // #fbdba7
    '--g-color-warning-300': '37 91% 73%',
    // #f9c97c
    '--g-color-warning-400': '37 91% 64%',
    // #f7b750
    '--g-color-warning-500': '37 91% 55%',
    // #f5a524
    '--g-color-warning-600': '37 74% 44%',
    // #c4841d
    '--g-color-warning-700': '37 74% 33%',
    // #936316
    '--g-color-warning-800': '37 75% 22%',
    // #62420e
    '--g-color-warning-900': '37 75% 16%',
    // #47300a
    '--g-color-warning-950': '37 75% 11%',
    // #312107
    '--g-color-warning-opacity': '1',
    '--g-color-warning-contrast': '0 0% 0%',
    // #000000

    '--g-color-info': '203 98% 60%',
    // #34b1fd
    '--g-color-info-50': '198 100% 97%',
    // #eefaff
    '--g-color-info-100': '197 100% 93%',
    // #dcf5ff
    '--g-color-info-200': '197 100% 88%',
    // #c3eeff
    '--g-color-info-300': '197 100% 78%',
    // #8fe0ff
    '--g-color-info-400': '199 100% 68%',
    // #5accff
    '--g-color-info-500': '203 98% 60%',
    // #34b1fd
    '--g-color-info-600': '207 90% 54%',
    // #2196f3
    '--g-color-info-700': '210 79% 46%',
    // #1976d2
    '--g-color-info-800': '210 74% 40%',
    // #1b67b3
    '--g-color-info-900': '210 69% 33%',
    // #1a548e
    '--g-color-info-950': '211 61% 21%',
    // #153456
    '--g-color-info-opacity': '1',
    '--g-color-info-contrast': '0 0% 0%' // #000000
  },

  shadow: {
    '--g-shadow-ambient-1': '0 0 2px',
    '--g-shadow-ambient-2': '0 0 2px',
    '--g-shadow-ambient-3': '0 0 2px',
    '--g-shadow-ambient-4': '0 0 2px',
    '--g-shadow-ambient-5': '0 0 8px',
    '--g-shadow-ambient-6': '0 0 8px',
    '--g-shadow-key-1': '0 1px 2px',
    '--g-shadow-key-2': '0 2px 4px',
    '--g-shadow-key-3': '0 4px 8px',
    '--g-shadow-key-4': '0 4px 16px',
    '--g-shadow-key-5': '0 14px 28px',
    '--g-shadow-key-6': '0 32px 64px',
    '--g-shadow-color': '0 0% 0%',
    '--g-shadow-ambient-opacity': '0.12',
    '--g-shadow-key-opacity': '0.14'
  }
};
function getVariables(variablesObject) {
  var css = '';
  for (var group in variablesObject) {
    for (var property in variablesObject[group]) {
      var value = variablesObject[group][property];
      if (typeof value === 'object') {
        css += "@media (min-width: ".concat(BREAKPOINTS.lg, ") {");
        for (var desktopProperty in value) {
          css += "".concat(desktopProperty, ": ").concat(value[desktopProperty], ";\n");
        }
        css += '}';
        continue;
      }
      css += "".concat(property, ": ").concat(value, ";\n");
    }
  }
  return css;
}
export function getAllGlobalCssVariables() {
  var css = '';
  css += getVariables(themeVariables);
  css += getVariables(skinVariables);
  return css;
}